import * as Yup from 'yup';
import * as formValdation from 'utils/formValidation';

import React, { useState } from 'react';

import { Formik } from 'formik';
import { editUser } from 'utils/editUser';
import { logError } from 'utils/errorLogger';
import EditUserForm from 'components/EditUser/EditUserForm';
import { mutate } from 'swr';
import { useMjrApiUser } from 'utils/swrCalls';

/**
 * EditInfoForm
 *
 * @param props - props passed in
 *
 * Top level component for order creation form
 * Controls submitting form and calls for validating
 * the warranty number
 *
 */
const EditUser = (props) => {
  const { buttonText, setOpen } = props;
  const { data: user } = useMjrApiUser();
  // get route params to determine if its an edit item or not
  const [state, setState] = useState({
    hasMessage: false,
    message: '',
    submit: false,
  });

  // form validation setup
  const validationSchema = Yup.object({
    firstName: formValdation.firstName,
    lastName: formValdation.lastName,
    phone: formValdation.phone,
  });

  const setError = (message) => {
    setState({
      hasMessage: true,
      message,
      submit: false,
    });
  };

  /**
   * editPersonalInfo
   *
   * @param formValues
   */
  const editPersonalInfo = async (formValues) => {
    // disable button
    setState({ submit: true });
    const formData = { ...user };
    formData.firstName = formValues.firstName;
    formData.lastName = formValues.lastName;
    formData.phone = formValues.phone;

    await editUser(formData)
      .then((response) => {
        const status = response?.status;
        if (status === 204 || status === 200) {
          // update redux
          mutate(`${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/customer/get`);
          // onEditUser(formData);
          // clean messages
          setState({
            hasMessage: false,
            message: '',
            submit: false,
          });
          // close modal
          setOpen(false);
        } else if (status === 400) {
          setError('The information you submitted could not be processed.');
        } else {
          logError(response, 'editPersonalInfo(1) - /Components/EditUserForm/index.js');
          setError('There was an issue with the server. Please try again later.');
        }
      })
      .catch((error) => {
        logError(error, 'editPersonalInfo(2) - /Components/EditUserForm/index.js');
        setError('There was an issue with the server. Please try again later.');
      });
  };

  /**
   * Handle Submit
   *
   * @param data - form data
   *
   * Handles adding an item to the cart when a user hits continue
   */
  const submit = (data) => {
    editPersonalInfo(data);
  };

  // default values for form
  const values = {
    firstName: user.firstName,
    lastName: user.lastName,
    phone: user.phone,
  };

  return (
    <div>
      <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
        {(props) => <EditUserForm {...props} buttonText={buttonText} message={state} submitting={state.submit} />}
      </Formik>
    </div>
  );
};

export default EditUser;
